import React, { useState, useEffect, useCallback } from "react";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import moment from "moment";

import Tank1 from "../../Assets/tank1.png";
import Tank2 from "../../Assets/tank2.png";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useLocation } from "react-router-dom";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import CommonService from "../../services/common.service";
Chart.register(ChartDataLabels);

function FuelStatusGraph() {
  const [progress, setProgress] = useState(0);
  const [tank1Data, setTank1Data] = useState({
    count: 0,
    percent: 0,
  });
  const [tank2Data, setTank2Data] = useState({
    count: 0,
    percent: 0,
  });
  const [data, setData] = useState([]);
  const [checked, setChecked] = useState("1");

  const [showCalendar, setShowCalendar] = useState(false);
  const [showCalendar2, setShowCalendar2] = useState(false);

  const [formdate, setFormdate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleCheck = (from) => setChecked(from);

  const location = useLocation();

  const locGangtok = location.pathname === "/gangtokDashboard";
  const locJallipool = location.pathname === "/jallipoolDashboard";
  const locJorethang = location.pathname === "/jorethangDashboard";

  // Get Data
  const fetchData = useCallback(() => {
    const req = {
      fdate: formdate,
      tdate: toDate,
      tanktype: checked,
      locid: locGangtok ? "1" : locJallipool ? "2" : locJorethang ? "3" : "",
    };

    const paylaod = {
      locid: locGangtok ? "1" : locJallipool ? "2" : locJorethang ? "3" : "",
      type: formdate !== "" || toDate !== "" ? "2" : "1",
      fromdate: formdate !== "" ? formdate : "",
      todate: toDate !== "" ? toDate : "",
    };

    const calculatePercent = (value, total) => {
      return (value / total) * 100;
    };

    CommonService.getFuelStatusGraph(req)
      .then((response) => {
        if (response.data) {
          // console.log(response.data);
          const x = response.data.reverse();
          setData(x);
        }
      })
      .catch((e) => console.log(e));

    CommonService.getDailyTotalfuel(paylaod)
      .then((resp) => {
        // console.log(resp.data);

        const total =
          parseInt(resp.data.indian_oli) + parseInt(resp.data.bharat_petroliam);

        setTank1Data({
          count: resp.data.indian_oli,
          percent: calculatePercent(resp.data.indian_oli, total),
        });
        setTank2Data({
          count: resp.data.bharat_petroliam,
          percent: calculatePercent(resp.data.bharat_petroliam, total),
        });
      })
      .catch((e) => console.log(e));
  }, [checked, formdate, toDate]);

  useEffect(() => {
    fetchData();
    if (location.pathname !== "/gangtokDashboard") {
      setProgress(0);
    }
  }, [fetchData]);

  const [details, setDetails] = useState({
    fromDate: "",
    formatedFromDate: "",
    toDate: "",
    formatedToDate: "",
  });

  const currentDate = new Date();

  const formatMonthYear = (locale, date) => {
    return `${date.getDate()} ${date.toLocaleDateString(locale, {
      month: "long",
    })}, ${date.getFullYear()}`;
  };

  const handleFromDateChange = (newValue) => {
    setFormdate(newValue);
    const addDays = new Date(
      newValue.getFullYear(),
      newValue.getMonth(),
      newValue.getDate() + 20
    );

    setToDate(currentDate);
    setDetails({
      ...details,
      fromDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(newValue)).format("DD-MM-YY"),
      toDate: moment(new Date(currentDate)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(currentDate)).format("DD-MM-YY"),
    });

    setShowCalendar(false);
  };

  const handleToDateChange = (newValue) => {
    setToDate(newValue);
    setDetails({
      ...details,
      toDate: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(newValue)).format("DD-MM-YY"),
    });
    setShowCalendar2(false);
  };

  const chartData1 = {
    labels: data.map((item) =>
      moment(item.transdate, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY")
    ),

    datasets: [
      {
        label: "Opening Balance",
        data: data.map((item) => item.openingbal),
        backgroundColor: "rgba(252, 148, 125, 1)",
        barPercentage: 0.75,
        categoryPercentage: 0.75,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 6,
          topRight: 6,
          bottomLeft: 6,
          bottomRight: 6,
        },
        borderSkipped: false,
      },
      {
        label: "Closing Balance",
        data: data.map((item) => item.cloasingbal),
        backgroundColor: "rgba(100, 221, 169, 1)",
        barPercentage: 0.75,
        categoryPercentage: 0.75,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 6,
          topRight: 6,
          bottomLeft: 6,
          bottomRight: 6,
        },
        borderSkipped: false,
      },
    ],
  };

  const chartData2 = {
    labels: data.map((item) =>
      moment(item.transdate, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY")
    ),
    datasets: [
      {
        label: "Opening Balance",
        data: data.map((item) => item.openingbal),
        backgroundColor: "rgba(252, 148, 125, 1)",
        barPercentage: 0.75,
        categoryPercentage: 0.75,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 6,
          topRight: 6,
          bottomLeft: 6,
          bottomRight: 6,
        },
        borderSkipped: false,
      },
      {
        label: "Closing Balance",
        data: data.map((item) => item.cloasingbal),
        backgroundColor: "rgba(100, 221, 169, 1)",
        barPercentage: 0.75,
        categoryPercentage: 0.75,
        borderWidth: 1,
        borderColor: "white",
        borderRadius: {
          topLeft: 6,
          topRight: 6,
          bottomLeft: 6,
          bottomRight: 6,
        },
        borderSkipped: false,
      },
    ],
  };

  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  });

  const footer = (tooltipItems) => {
    let sum = {};

    if (tooltipItems[0].dataset.label === "Closing Balance") {
      tooltipItems.forEach(function (tooltipItem) {
        sum = data.filter(
          (itm) =>
            moment(itm.transdate, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YY") ===
            tooltipItem.label
        );
      });

      return `Amount: ₹${formatter.format(
        sum[0].chalanAmount
      )}/-\nFuel Added: ${sum[0].tank} Ltrs`;
    } else {
      return;
    }
  };

  const options = {
    responsive: true,
    offset: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },
        border: {
          display: false,
        },
        title: {
          display: true,
          text: "Fuel (LTRs)",
        },
      },
    },

    plugins: {
      legend: {
        display: true,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
      tooltip: {
        displayColors: false,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.formattedValue;
            return `${label}: ${value} Ltrs`;
          },
          afterBody: footer,
        },
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },

        // usePointStyle: true,
      },

      // Custom plugin to render labels above bars
      datalabels: {
        display: true,
        align: "end",
        anchor: "end",
        formatter: (value, context) => {
          return value;
        },

        color: "rgba(152, 141, 170, 1)",
      },
    },
  };

  const handleLastFive = () => {
    setFormdate("");
    setToDate("");
    setDetails({
      fromDate: "",
      formatedFromDate: "",
      toDate: "",
      formatedToDate: "",
    });
  };

  return (
    <>
      <div>
        <div className="graph-header">
          <div className="graph-heading">Fuel Status</div>
          <div className="graph-yearly-filter">
            <div className={"filter-box active"} onClick={handleLastFive}>
              Last 7 Entries
            </div>
            <div className="date-range" style={{ display: "flex" }}>
              <div className="flex position-relative">
                <span>
                  {details.formatedFromDate !== ""
                    ? details.formatedFromDate
                    : "From"}
                </span>
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={(e) => {
                      setShowCalendar(!showCalendar);
                      setShowCalendar2(false);
                    }}
                  >
                    <path
                      d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                      stroke="#6E6284"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                {showCalendar && (
                  <div className="calendarModal position-absolute">
                    <Calendar
                      formatMonthYear={formatMonthYear}
                      onChange={handleFromDateChange}
                      value={formdate}
                      maxDate={currentDate}
                      // selectRange
                    />
                  </div>
                )}
              </div>
              <div className="flex position-relative">
                <span>
                  {details.formatedToDate !== ""
                    ? details.formatedToDate
                    : "To"}
                </span>
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={(e) => {
                      setShowCalendar2(!showCalendar2);
                      setShowCalendar(false);
                    }}
                  >
                    <path
                      d="M2.5 8.33333H17.5M5.83333 2.5V4.16667M14.1667 2.5V4.16667M5.16667 17.5H14.8333C15.7667 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V6.83333C17.5 5.89991 17.5 5.4332 17.3183 5.07668C17.1586 4.76307 16.9036 4.50811 16.59 4.34832C16.2335 4.16667 15.7667 4.16667 14.8333 4.16667H5.16667C4.23325 4.16667 3.76653 4.16667 3.41002 4.34832C3.09641 4.50811 2.84144 4.76307 2.68166 5.07668C2.5 5.4332 2.5 5.89991 2.5 6.83333V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76653 17.5 4.23324 17.5 5.16667 17.5Z"
                      stroke="#6E6284"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                {showCalendar2 && (
                  <div className="calendarModal position-absolute">
                    <Calendar
                      // formatMonthYear={formatMonthYear}
                      onChange={handleToDateChange}
                      value={toDate}
                      minDate={formdate}
                      maxDate={currentDate}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <div className="d-flex justify-content-end gap-2">
            <label class="radio-container">
              Indian Oil
              <input
                type="radio"
                checked={checked === "1"}
                onChange={() => handleCheck("1")}
                name="fuelStatus"
              />
              <span class="checkmark"></span>
            </label>
            <label class="radio-container">
              Bharat Petroleum
              <input
                type="radio"
                checked={checked === "2"}
                onChange={() => handleCheck("2")}
                name="fuelStatus"
              />
              <span class="checkmark"></span>
            </label>
          </div> */}
        </div>
        {/* <div className="slider-area-flex mt-2">
          <div className="slider-flex justify-content-start">
            <div className="slider-left">
              <div className="slider2 mt-3">
                <div className="w-50">
                  <div className="slidecontainer">
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <ProgressBar
                        variant="danger"
                        now={tank1Data.percent}
                        key={1}
                      />
                      <img
                        src={Tank1}
                        alt="Progress Icon"
                        height={20}
                        style={{
                          position: "absolute",
                          top: "47%",
                          left: `${parseInt(tank1Data.percent - 4)}%`,
                          transform: "translate(-50%, -50%)",
                        }}
                      />
                    </div>
                  </div>
                  <div className="sliderval">
                    <span>
                      <span>Indian Oil : {tank1Data.count} Ltr</span>
                    </span>
                  </div>
                </div>
                <div className="w-50">
                  <div className="slidecontainer">
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <ProgressBar
                        variant="warning"
                        now={tank2Data.count}
                        key={1}
                      />
                      <img
                        src={Tank2}
                        alt="Progress Icon"
                        height={22}
                        style={{
                          position: "absolute",
                          top: "47%",
                          left: `${tank2Data.percent}%`,
                          transform: "translate(-50%, -50%)",
                        }}
                      />
                    </div>
                  </div>
                  <div className="sliderval">
                    <span>
                      <span>Bharat Petroleum : {tank2Data.count} Ltr</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {checked === "1" ? (
        <>
          {/* <div
            className={`${showCalendar ? "modal-overlay" : ""}`}
            onClick={() => {
              setShowCalendar(false);
            }}
          >
            <div className="" onClick={(e) => e.stopPropagation()}></div>
          </div>
          <div
            className={`${showCalendar2 ? "modal-overlay" : ""}`}
            onClick={() => {
              setShowCalendar2(false);
            }}
          >
            <div className="" onClick={(e) => e.stopPropagation()}></div>
          </div> */}
          <div className="">
            <Bar data={chartData1} options={options} width={600} height={300} />
          </div>
        </>
      ) : checked === "2" ? (
        <>
          <div className="">
            <Bar data={chartData2} options={options} width={600} height={300} />
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default FuelStatusGraph;
